@if (loading()) {
  <div class="circular-metric">
    <div class="metric-circle skeleton"></div>
    <div class="skeleton-text"></div>
  </div>
} @else {
  <div class="circular-metric">
    <div class="metric-circle" [ngClass]="colorClass()">{{ value() }}</div>
    <div class="metric-label">{{ label() }}</div>
  </div>
}
